import {
    DELETE_USERDETAILS_SUCCESS,
    DELETE_USERDETAILS_FAILED,
    RESET_DELETE_USERDETAILS,
    LOADING_DELETE_USERDETAILS,
    DELETE_USERDETAILS_NETWORKERROR
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETE_USERDETAILS:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DELETE_USERDETAILS_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DELETE_USERDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case DELETE_USERDETAILS_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DELETE_USERDETAILS:
            return (state = initialState);
        default:
            return state;
    }
};
